import { authRef } from 'config'

export const resetPassword = (
  code: string,
  newPassword: string,
  successCallback: () => void,
  errorCallback: (e) => void
) => async dispatch => {
  try {
    await authRef.confirmPasswordReset(code, newPassword)
    successCallback()
  } catch (e) {
    errorCallback(e)
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/resetPassword.action.ts